import { render, staticRenderFns } from "./StepsSecondAddCourse.vue?vue&type=template&id=06e3402a&scoped=true"
import script from "./StepsSecondAddCourse.vue?vue&type=script&lang=js"
export * from "./StepsSecondAddCourse.vue?vue&type=script&lang=js"
import style0 from "./StepsSecondAddCourse.vue?vue&type=style&index=0&id=06e3402a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e3402a",
  null
  
)

export default component.exports